import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const captureTreeMapAsPDF = () => {
  return new Promise((resolve, reject) => {
    const fileName = "TreeMapTest";
    const pageWidth = 210;
    const pageHeight = 2385; // in mm
    const doc = new jsPDF();
    const topOffset = 300; // Adjust this value to leave space from the top

    try {
      // Function to capture and add content to PDF pages
      const addContentToPDF = (offset = 0) => {
        html2canvas(document.body, {
          y: topOffset + offset, // Start capture after the top offset
          height: pageHeight, // Fixed height for each page
        })
          .then((canvas) => {
            // Add the captured image to the PDF
            const imageData = canvas.toDataURL("image/png");
            const imgHeight = (canvas.height * pageWidth) / canvas.width;

            doc.addImage(imageData, "PNG", 0, 0, pageWidth, imgHeight);

            // Check if there's more content below
            if (topOffset + offset + pageHeight < document.body.clientHeight) {
              doc.addPage(); // Add a new page
              addContentToPDF(offset + pageHeight); // Recursively add content to the next page
            } else {
              // Save the PDF as a blob
              const pdfBlob = doc.output("blob");

              // Create a download link
              const a = document.createElement("a");
              a.href = URL.createObjectURL(pdfBlob);
              a.download = `${fileName}.pdf`;

              // Simulate a click on the link to trigger the download
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(a.href);
              resolve("Download Complete");
            }
          })
          .catch((error) => {
            reject(`Error generating PDF: ${error}`);
          });
      };

      // Add content to PDF
      addContentToPDF();
    } catch (error) {
      console.error("Error generating PDF:", error);
      reject("Error generating PDF: ", error);
    }
  });
};
